import React from 'react';
import { Badge } from '@/components/ui/badge';
import { ProductInterestBadge } from './ProductInterestBadge';
import { MemberProductInterest } from '@/types/member-product-interests';
import { Package } from 'lucide-react';

interface ProductInterestsListProps {
  interests: MemberProductInterest[];
  maxVisible?: number;
  showLevels?: boolean;
  compact?: boolean;
}

export const ProductInterestsList: React.FC<ProductInterestsListProps> = ({ 
  interests,
  maxVisible = 3,
  showLevels = false,
  compact = false
}) => {
  const visibleInterests = interests.slice(0, maxVisible);
  const remainingCount = interests.length - maxVisible;

  if (interests.length === 0) {
    return null;
  }

  return (
    <div className={`${compact ? 'space-y-2' : 'space-y-3'}`}>
      <div className="flex items-center gap-2">
        <Package className="w-4 h-4 text-muted-foreground" />
        <span className="text-sm font-medium text-muted-foreground">
          Intéressé par
        </span>
      </div>
      
      <div className="flex flex-wrap gap-2">
        {visibleInterests.map((interest) => (
          <ProductInterestBadge 
            key={interest.id}
            interest={interest}
            showLevel={showLevels}
          />
        ))}
        
        {remainingCount > 0 && (
          <Badge variant="outline" className="text-xs px-2 py-1">
            +{remainingCount} autres
          </Badge>
        )}
      </div>
    </div>
  );
};